"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagMT = function FlagMT(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54-122H11.8V146.36H209.54a7.06,7.06,0,0,0,7.06-7.06V-114.94a7.06,7.06,0,0,0-7.06-7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-185.94,146.36H11.8V-122H-185.94a7.06,7.06,0,0,0-7.06,7.06V139.3a7.06,7.06,0,0,0,7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-134.15-105.52v18.9A4.8,4.8,0,0,1-131-85.15,4.87,4.87,0,0,1-129.5-82h18.89v18.83H-129.5A4.92,4.92,0,0,1-131-60a4.92,4.92,0,0,1-3.17,1.48v18.89H-153V-58.5A4.92,4.92,0,0,1-156.15-60a4.8,4.8,0,0,1-1.47-3.17h-18.9V-82h18.9a4.8,4.8,0,0,1,1.47-3.17A4.8,4.8,0,0,1-153-86.62v-18.9h18.83m2.35-2.35h-23.54v19.39a7.55,7.55,0,0,0-2.47,1.67,7.55,7.55,0,0,0-1.67,2.47h-19.4V-60.8h19.4a7.49,7.49,0,0,0,1.67,2.48,7.71,7.71,0,0,0,2.47,1.67v19.39h23.54V-56.65a7.75,7.75,0,0,0,2.48-1.67,7.64,7.64,0,0,0,1.67-2.48h19.39V-84.34h-19.39a7.55,7.55,0,0,0-1.67-2.47,7.59,7.59,0,0,0-2.48-1.67Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-110.61-82h-23.54v-23.54H-153V-82h-23.54v18.83H-153v23.54h18.83V-63.15h23.54Zm0,0",
    transform: "translate(194 123)",
    fill: "#cdcdcd"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-134.15-72.57a9.42,9.42,0,0,1-9.42,9.42A9.41,9.41,0,0,1-153-72.57,9.41,9.41,0,0,1-143.57-82a9.41,9.41,0,0,1,9.42,9.41Zm0,0",
    transform: "translate(194 123)",
    fill: "#b4a08c"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-157-65c1.15-1.14,3.4-.74,5,.89s2,3.89.89,5-3.4.74-5-.89-2-3.89-.89-5Zm0,0",
    transform: "translate(194 123)",
    fill: "#b4a08c"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-130.09-65c1.14,1.14.74,3.4-.89,5s-3.89,2-5,.89-.74-3.4.9-5,3.88-2,5-.88Zm0,0",
    transform: "translate(194 123)",
    fill: "#b4a08c"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-130.1-80.11c-1.15,1.14-3.4.74-5-.89s-2-3.89-.89-5,3.39-.74,5,.9,2,3.88.89,5Zm0,0",
    transform: "translate(194 123)",
    fill: "#b4a08c"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-157-80.12c-1.14-1.14-.75-3.39.89-5s3.89-2,5-.89.75,3.4-.89,5-3.89,2-5,.88Zm0,0",
    transform: "translate(194 123)",
    fill: "#b4a08c"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-143.57-59.68a12.91,12.91,0,0,1-12.89-12.89,12.91,12.91,0,0,1,12.89-12.89,12.91,12.91,0,0,1,12.89,12.89,12.9,12.9,0,0,1-12.89,12.89Zm0-24.6a11.73,11.73,0,0,0-11.71,11.71,11.73,11.73,0,0,0,11.71,11.72,11.74,11.74,0,0,0,11.72-11.72,11.73,11.73,0,0,0-11.72-11.71Zm0,0",
    transform: "translate(194 123)",
    fill: "#b4a08c"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagMT;
exports["default"] = _default;